import { getBirthDate } from './getBirthDate';
import { isValidDate } from './isValidDate';

/** Returns the first day of the month the employee turns the given age
 * Ex) getLastDayofMonthBeforeBirthdayFromEmployeeId('20110915-1234', 100) returns '2111-08-31'
 */
export const getLastDayofMonthBeforeBirthdayFromEmployeeId = (employeeId: string, age: number): string => {
  const date = getBirthDate(employeeId);
  if (!date || !isValidDate(date)) {
    return '';
  }
  // setting date to 0 means setting it to the last day of the predecent month
  return new Date(Date.UTC(date.getFullYear() + age, date.getMonth(), 0)).toISOString().split('T')[0];
};
